import { gql, useMutation, useQuery } from '@apollo/client'
import CancelIcon from '@mui/icons-material/Cancel'
import EditIcon from '@mui/icons-material/Edit'
import {
  CircularProgress,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import Modal from 'components/Modal'
import React, { useState } from 'react'
import { Timeline } from 'utils/__generated__/graphql'

import { TimelineDataType, TimelineForm } from '../Create'
import { TIMELINE_BASE_QUERIES, TIMELINE_FRAGMENT } from '../constants'

const UPDATE_TIMELINE = gql`
  ${TIMELINE_FRAGMENT}
  mutation UPDATE_TIMELINE($id: ID!, $timeline: TimelineInput!) {
    updateTimeline(id: $id, timeline: $timeline) {
      ...TimelineFragment
    }
  }
`

function Edit({ timeline }: { timeline: Timeline }) {
  const [open, setOpen] = useState<boolean>(false)

  const theme = useTheme()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const [updateTimeline] = useMutation(UPDATE_TIMELINE)

  const handleTimeline = (data: TimelineDataType) => {
    updateTimeline({
      variables: { id: timeline.id, timeline: data },
      onCompleted: handleClose,
    })
  }

  const { loading, data } = useQuery(TIMELINE_BASE_QUERIES, {
    variables: { siteFilter: { isPublished: true }, companyFilter: {} },
    skip: !open,
  })

  const sites = data?.sites || []
  const companies = data?.companies || []

  const formValues = {
    site: timeline.site?.id || '',
    name: timeline.name || '',
  }

  return (
    <React.Fragment>
      <Modal open={open} width="75%" maxWidth={720}>
        <Stack
          direction="row"
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Typography
            sx={{ ...theme.typography.h5, color: theme.palette.text.primary }}
          >
            Edit - {timeline.name}
          </Typography>
          <CancelIcon
            onClick={handleClose}
            sx={{ cursor: 'pointer', color: theme.palette.error.main }}
          />
        </Stack>
        <Divider sx={{ mt: 1, mb: 1 }} />
        {loading ? (
          <Stack sx={{ alignItems: 'center', p: 4 }}>
            <CircularProgress size={20} />
          </Stack>
        ) : (
          <TimelineForm
            values={formValues}
            onTimeline={handleTimeline}
            sites={sites}
            companies={companies}
          />
        )}
      </Modal>
      <IconButton onClick={handleOpen}>
        <Tooltip title="Edit" placement="top">
          <EditIcon />
        </Tooltip>
      </IconButton>
    </React.Fragment>
  )
}

export default Edit
